/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const addressFormFieldsSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	'& .MuiOutlinedInput-root': {
		borderRadius: '6px',
		'&:hover:not(.Mui-focused) fieldset': {
			borderColor: '#C9C9C9 !important',
		},
	},
	'& input:-webkit-autofill': {
		WebkitBoxShadow: '0 0 0px 1000px white inset',
	},
	'& .MuiFormHelperText-root': {
		marginLeft: '0px !important',
		fontSize: 'var(--font-size-caption)',
	},
};

export const addressFormGridSX: SxProps<Theme> = () => ({
	pt: { xs: '24px !important', sm: '16px !important' },
});
